import { Avatar, Button, Text } from '@mantine/core';
import { first } from 'lodash/fp';
import React from 'react';

import { PartnerTypeSelection } from '../components/PartnerTypeSelection';
import { StepsFooter } from '../components/StepsFooter';
import { StepsHeader } from '../components/StepsHeader';
import { useInvitePartnerWizard } from '../hooks';

export function ExistingPartnerType() {
  const { contextData, onPrev, isNextDisabled } = useInvitePartnerWizard();
  const { selectedPartner } = contextData;

  return (
    <>
      <StepsHeader
        title={
          <>
            What is your relationship with&nbsp;
            <Text span weight={700}>
              {selectedPartner?.label}
            </Text>
          </>
        }
        icon={
          <Avatar
            size="xl"
            color="blue"
            src={selectedPartner?.logo}
            sx={{ borderRadius: '50%' }}
          >
            {first(selectedPartner?.label)}
          </Avatar>
        }
      />

      <PartnerTypeSelection />

      <StepsFooter>
        <Button variant="default" onClick={onPrev}>
          Back
        </Button>

        <Button
          loading={contextData.isLoading}
          disabled={isNextDisabled}
          onClick={contextData.onInviteExisting}
        >
          Invite
        </Button>
      </StepsFooter>
    </>
  );
}
